module.exports = __webpack_public_path__ + "static/media/logo-menu.b90bd6ea.png";